import { track } from '@vercel/analytics';
import { ToolType } from '@/lib/structured-data/tools';

/**
 * Tracks tool usage with Vercel Analytics
 * Uses only 2 custom data fields as per Vercel's limitation
 */
export function trackToolUsage(tool: ToolType, url?: string) {
  const currentUrl = url || (typeof window !== 'undefined' ? window.location.pathname : '');
  
  track('Used Tool', {
    tool,
    url: currentUrl
  });
}


/**
 * Immediate tracking for significant user actions
 * Use for button clicks, form submissions, etc.
 */
export function trackToolAction(tool: ToolType, action: string, url?: string) {
  const currentUrl = url || (typeof window !== 'undefined' ? window.location.pathname : '');
  
  track('Tool Action', {
    tool,
    url: currentUrl,
    action
  });
}
